import React, { useState } from 'react'
import styled, { theme } from '../../theme'
import { useTranslation } from 'react-i18next'
import EmployeeIcon from '../../assets/icons/employee.svg'
import { mapScopeGroupToString } from './index'
import { IconButton } from '@material-ui/core'
import { FiEdit2, FiTrash } from 'react-icons/fi'
import DeleteModal from './DeleteModal'
import { EmployeesAction } from '../../reducers/employees/actionNames'
import { useDispatch, useSelector } from 'react-redux'
import sendEmailPassword from '../../models/User/sendEmailPassword'
import { fireToastSuccess } from '../../actions/toasts/fireToast'
import { is } from '../../components/MediaQuery'
import { Mixpanel } from '../../utils/Mixpanel'
import { getUserId } from '../../reducers/userAccount/selectors/userAccount'
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  background-color: #ffffff;
  background-size: cover;
  font-family: Roboto, sans-serif;
  margin-top: 15px;
  font-size: 12px;
  color: #121212;
  text-decoration: none solid rgb(18, 18, 18);
  margin-right: 15px;
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    margin-right: 0px;
  }
`

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 15px;
`
const TextWrapper = styled.div``
const Text = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  color: #000000;
  text-decoration: none solid rgb(0, 0, 0);
  text-align: left;
`
const Link = styled.div`
  margin-top: 10px;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: #17a3dd;
  text-decoration: none solid rgb(23, 163, 221);
  letter-spacing: 0.1px;
  cursor: pointer;
  text-align: left;
`

const ButtonWrapper = styled.div`
  margin-left: auto;
  min-width: 80px;
`

const Note = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  color: #272728;
  text-decoration: none solid rgb(39, 39, 40);
  text-align: justify;
  margin-top: 10px;
  white-space: pre-line;
  margin-left: 39px;
  word-break: break-all;
`

function Employee({ e }: any) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()
  const [sended, setSended] = useState(false)
  const userId = useSelector(getUserId)
  const isDesktop = is.desktop()

  const sendResetPassword = () => {
    if (!sended) {
      Mixpanel.track('Employees List Reset Password Clicked', {
        'Employee ID': e.id,
      })

      setSended(true)
      try {
        sendEmailPassword(e.email).catch(() => {
          setSended(false)
        })
        Mixpanel.track('Employees List Reset Password Complete', {
          'Employee ID': e.id,
        })
        dispatch(fireToastSuccess(t('OUT_4234_message_has_been_sent')))
      } catch (e) {
        console.error(e)
      }
    }
  }

  const deleteEmployee = () => {
    dispatch({ type: EmployeesAction.DeleteEmployee, payload: e.id })
    Mixpanel.track('Employees List Delete Completed', {
      'Employee ID': e.id,
    })
    Mixpanel.people.increment(userId, 'Employee Record Deleted', 1)
  }

  const editEmployee = () => {
    dispatch({ type: EmployeesAction.EditEmployee, payload: e.id })
    Mixpanel.track('Employees List Edit Employee Button Clicked', {
      'Employee ID': e.id,
    })
  }

  const handleClose = () => {
    Mixpanel.track('Employees List Delete Abandoned', {
      'Employee ID': e.id,
    })
    setOpen(false)
  }

  const handleDelete = () => {
    Mixpanel.track('Employees List Delete Employee Button Clicked', {
      'Employee ID': e.id,
    })
    setOpen(true)
  }

  const formatName = (name: string) => {
    if (name.length > (isDesktop ? 50 : 25)) {
      return name.substring(0, isDesktop ? 50 : 25) + '...'
    }
    return name
  }

  const formatNote = (note: string) => {
    if (!note) return ''

    let lines = note.split('\n')

    const more = lines.length > 4
    lines = lines.splice(0, 4)

    let n = lines.join('\n')
    if (more) {
      n += '...'
    }

    return n
  }

  return (
    <Wrapper>
      <DeleteModal
        handleClose={handleClose}
        open={open}
        id={e.id}
        action={deleteEmployee}
      />
      <InnerWrapper>
        <Icon src={EmployeeIcon} alt={'employee icon'} />
        <TextWrapper>
          <Text style={{ marginBottom: '10px', fontWeight: 'bold' }}>
            {formatName(e.name + ' ' + e.surname)}
          </Text>
          <Text>{t(mapScopeGroupToString(e.scope_group))}</Text>
          <Link onClick={sendResetPassword}>{t('OUT_4234_change_password_button')}</Link>
        </TextWrapper>
        <ButtonWrapper>
          <IconButton data-cy={'employee-edit'} onClick={editEmployee}>
            <FiEdit2 style={{ fontSize: '16px' }} />
          </IconButton>
          <IconButton data-cy={'employee-delete'} onClick={handleDelete}>
            <FiTrash
              style={{ fontSize: '16px', color: theme.colors.palette.reddish }}
            />
          </IconButton>
        </ButtonWrapper>
      </InnerWrapper>
      {e.notes && (
        <Note dangerouslySetInnerHTML={{ __html: formatNote(e.notes) }} />
      )}
    </Wrapper>
  )
}

export default Employee
